<template>
  <Toolbar class="p-mb-4 p-mt-4 p-p-2">
    <template #start>
      <div style="font-size: 1.4em; color: inherit" class="p-p-2">{{ $t('Companies') }}</div>
<!--      <div class="p-p-1" v-show="$store.getters.effectiveRole === constants.userRoles.superAdmin">-->
      <div class="p-p-1" v-if="!$store.getters.isTrialTenant">
        <AddNewButton :disabled="tenantDataIsLoading || (items?.length >= 5 && $store.getters.effectiveRole !== constants.userRoles.superAdmin)"
                      :loading="tenantDataIsLoading"
                      :label="$t('Add')"
                      @click="addNewItem"/>
      </div>
    </template>
  </Toolbar>

  <Spinner v-if="isLoading"/>
  <DesktopDataTable v-else
                    :dataTableIsLoading="dataTableIsLoading"
                    :showHeader="false"
                    :itemsArrayIsEmpty="itemsArrayIsEmpty"
                    :sort="sort"
                    :showSearchInput="false"
                    :actionButtonsCount="actionButtonsCount"
                    @sort-items="sortItems"
                    :headers="[
                      {name: 'name', title: $t('Name'), sortable: false},
                      {name: 'status', title: $t('active'), sortable: false},
                      {name: 'reg_number', title: $t('Reg. number'), sortable: false},
                      {name: 'tax_number', title: $t('VAT number'), sortable: false},
                      {name: 'default_tax', title: $t('defaultVatRateLabel'), sortable: false},
                      {name: 'address', title: $t('legalAddressLabel'), sortable: false},
                      // {name: 'country_name', title: $t('Country'), sortable: false},
                      // {name: 'privacy_email', title: $t('Privacy Email'), sortable: false},
                      {name: 'privacy_email', title: $t('Email'), sortable: false},
                      {name: 'billing_email', title: $t('Billing Email'), sortable: false},
                      // {name: 'privacy_phone', title: 'Privacy Phone', sortable: false},
                      {name: 'created_at', title: $t('Created'), sortable: true},
                      // {name: 'sorting', title: 'Sorting', sortable: true},
                  ]">
    <template v-slot:body>
      <tr v-for="item of items"
          :key="item.id"
          :class="{'updated-item': isItemUpdated(item.id)}">
        <td>
          <span v-if="item.name">{{ item.name }}</span>
          <i v-else class="ti-minus"/>
        </td>
        <td>
          <i class="pi pi-check green-color" v-if="item.status === 1"/>
          <i class="pi pi-times warning-color" v-else/>
        </td>
        <td>
          <span v-if="item.reg_number">{{ item.reg_number }}</span>
          <i v-else class="ti-minus"/>
        </td>
        <td>
          <span v-if="item.tax_number">{{ item.tax_number }}</span>
          <i v-else class="ti-minus"/>
        </td>

        <td>
          <span v-if="item.default_tax">{{ formatDecimal(item.default_tax.value) }}%</span>
          <i v-else class="ti-minus"/>
        </td>

        <td>
          <div v-if="addressLine(item)">
            <span>{{ addressLine(item) }}</span>
          </div>
          <i v-else class="ti-minus"/>
        </td>

        <td>
          <span v-if="item.privacy_email">{{ item.privacy_email }}</span>
          <i v-else class="ti-minus"/>
        </td>

        <td>
          <span v-if="item.billing_email">{{ item.billing_email }}</span>
          <i v-else class="ti-minus"/>
        </td>

        <td class="table-date-line">
          <span v-if="item.created_at">
            {{ formatBy(item.created_at, item.creator) }}
          </span>
          <i v-else class="ti-minus"/>
        </td>
        <td v-show="actionButtonsCount">
          <div class="actions">
            <EditButton :allowWhenBillingLocked="true"
                        :disabled="!canManage || dataTableIsLoading || tenantDataIsLoading"
                        @click="editItem(item)"/>
          </div>
        </td>
      </tr>
    </template>
  </DesktopDataTable>


  <OwnPaginator v-show="items && items.length"
                :rows="pagination.perPage"
                :currentPage="pagination.currentPage - 1"
                :totalPages="pagination.pageCount"
                :totalRecords="pagination.totalCount"
                :rowsPerPageOptions="[5,10,25,50,100,200]"
                :pageLinkSize="11"/>

  <TotalRecordsData :pagination="pagination" :itemsArrayIsEmpty="itemsArrayIsEmpty"/>


  <TenantCompanyModal :visible="itemModal"
                      :item="item"
                      @update-items="updateItems"
                      @close="closeItemModal"/>
</template>

<script>
import httpClient from '@/services/http.services'
import datatableMixins from "@/mixins/datatableMixins";
import settings from "@/settings";
import showErrorsMixins from "@/mixins/showErrorsMixins";
import formatMixins from "@/mixins/formatMixins";
import TenantCompanyModal from "@/pages/account/components/TenantCompanyModal";
import labelMixin from "@/mixins/labelMixin";
import constants from "@/constants";

export default {
  mixins: [ datatableMixins, showErrorsMixins, formatMixins, labelMixin ],
  components: { TenantCompanyModal },
  props: {
    // tenant: [Object,null],
    tenantDataIsLoading: {
      type: Boolean,
      default: false
    },
  },
  watch: {
    '$route'() {
      const route = this.$route.path.split('/')
      if (this.$route.path === '/login' || route.indexOf('account') === -1 || route.indexOf('companies') === -1) {
        return false
      }
      this.checkRouteQuery()
      this.getItems()
    },
  },
	data() {
		return {
      fieldsExpand: 'country_name,creator,default_tax',
      apiLink: 'tenant-company',
      routePath: '/companies',
      sort: {
        column: 'id',
        direction: '-',
      },
      constants
		}
	},
  mounted() {
    if (settings.autoLogoutTimeout && this.$store.state.logoutTimestampIsOverdue) return false
    this.checkRouteQuery()
    this.$store.commit('SET_FETCH_IN_FLIGHT', false)
    this.getPageData()
	},
  methods: {
    getPageData() {
      this.getItems()
    },
    async getItems() {
      if (!this.userCanGetData || this.fetchInFlight) return
      this.$store.commit('SET_FETCH_IN_FLIGHT', true)
      this.dataTableIsLoading = true
      const ctrl = this.setController?.('tenantCompanies')
      try {
        const { status, data, headers } = await httpClient({
          url: this.apiLink,
          params: {
            page: this.pagination.currentPage,
            'per-page': this.pagination.perPage,
            sort: this.sort.direction + this.sort.column,
            search: this.processedSearchValue ?? null,
            expand: this.fieldsExpand,
          },
          signal: ctrl?.signal
        })
        if (status === 200 && data && Array.isArray(data)) {
          const hasPaginationHeaders = !!headers['x-pagination-total-count']
          if (hasPaginationHeaders) {
            this.pagination.totalCount = +headers['x-pagination-total-count']
            this.pagination.pageCount  = +headers['x-pagination-page-count']
          } else {
            this.pagination.totalCount = data.length
            this.pagination.pageCount  = 1
          }

          this.items = data

          if (!data.length) {
            this.pagination.pageCount = 1
            this.pagination.currentPage = 1
          }
        } else {
          this.items = []
          this.showUnknownError()
        }
      } catch(err) {
        this.items = []
        this.showError(err)
      } finally {
        this.$store.commit('SET_FETCH_IN_FLIGHT', false)
        this.dataTableIsLoading = false
        this.isLoading = false
        if (ctrl && this._abortors?.tenantCompanies === ctrl) {
          this._abortors.tenantCompanies = null
        }
      }
    },
	},
  computed: {
    canManage() {
      return this.$store.getters.isOwnerOrHigher
    },
    actionButtonsCount() {
      return this.canManage ? 1 : 0
    },
  }
}
</script>
<style scoped lang="scss">
td {
  height: 44px;
}
</style>